<template>
  <div>
    <p v-if="density !== 'compact'">
      Theme
    </p>
    <v-btn-toggle
      v-model="theme"
      :density="density"
      mandatory
      border
      divided
    >
      <v-tooltip
        v-for="themeInfo of themeList"
        :key="themeInfo.value"
        location="top"
      >
        <template #activator="{ props }">
          <v-btn
            v-bind="props"
            :value="themeInfo.value"
            :size="size"
            :density="density"
          >
            <v-icon :icon="themeInfo.icon" />
          </v-btn>
        </template>
        <span v-text="themeInfo.name" />
      </v-tooltip>
    </v-btn-toggle>
  </div>
</template>

<script lang="ts">
import { useColorMode } from '@vueuse/core'
import { defineComponent, computed } from 'vue'

import type { PropType } from 'vue'

interface ThemeDetail {
  name: string
  icon: string
  value: string
}

export default defineComponent({
  name: 'ThemeSwitcher',

  props: {
    /**
     * If specified as `'x-small'` or `'small'`, the `compact` density will be used.
     *
     * @default
     * 'default'
     */
    size: { type: String as PropType<'x-small' | 'small' | 'default'>, default: 'default' },
  },

  setup (props) {
    const { store: theme } = useColorMode()

    const density = computed(() => {
      return ['x-small', 'small'].includes(props.size) ? 'compact' : 'default'
    })

    const themeList = computed<ThemeDetail[]>(() => {
      return [
        {
          name: 'Light',
          icon: 'mdi-white-balance-sunny',
          value: 'light',
        },
        {
          name: 'Dark',
          icon: 'mdi-moon-waxing-crescent',
          value: 'dark',
        },
        {
          name: 'Auto',
          icon: 'mdi-laptop',
          value: 'auto',
        },
      ]
    })

    return {
      theme,
      density,
      themeList,
    }
  },
})
</script>
